// src/components/AdminLogin.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import FormLogin from './componentes/FormLogin';
import DecoLogin from './componentes/DecoLogin';

function AdminLogin() {
    const getCurrentYear = () => {
        return new Date().getFullYear();
    };
    return (
        <Container fluid className="p-0 bg-black vh-100 d-flex flex-column">
            <Row className="flex-grow-1 m-0">
                {/* Columna de Formulario */}
                <Col
                    md={7}
                    className="p-0 d-flex align-items-center justify-content-center">
                    <FormLogin />
                </Col>

                {/* Columna de Decoración */}
                <Col
                    md={5}
                    className="d-none d-md-flex flex-column justify-content-center align-items-center p-0">
                    <DecoLogin />
                </Col>
            </Row>
            <footer className="mx-4 mb-2 text-white fixed-bottom">
                <Row className="align-items-center">
                    <Col xs={12} md={6} className="text-center text-md-start mb-2 mb-md-0">
                        <div className="mb-0">
                            Desarrollado por
                            <small className='text-decoration-none fw-bold'><a href="https://tubisnez.netlify.app/" target="_blank" rel="noopener noreferrer" className='text-decoration-none text-danger'> TuBisnez</a> &copy; 2024 - {getCurrentYear()}</small>
                        </div>
                    </Col>
                </Row>
            </footer>
        </Container>
    );
}

export default AdminLogin;
